import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import Image from '@/app/components/Image';

const UIScreens = () => {
  return (
    <section className="py-10 lg:px-8 lg:py-20" data-cy="ui-screens">
      <LayoutGrid>
        <GridItem
          colEnd={{ sm: 'full', xl: 'main' }}
          colStart={{ sm: 'full', xl: 'main' }}
          className="overflow-hidden"
        >
          <div className="relative aspect-2600/1341 w-[123%] max-lg:left-[50%] max-lg:translate-x-[-50%] lg:w-full">
            <Image
              localizedAlt="membership_redesign_app_ui_collage_alt"
              localizedSrc="membership_redesign_app_ui_collage"
              fill
              format="png"
              sizes="100vw"
              className="object-contain"
              data-cy="app-ui-screens-image"
            />
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default UIScreens;
